import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Typography, CircularProgress } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api } from "../../api/api";
import GradientButton from "./GradiantButton";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendOtp = async () => {
    if (!email) {
      toast.error("Please enter your registered email");
      return;
    }
    setLoading(true);
    try {
      const res = await api.sendOtp({ email });
      if (res.status === 200) {
        toast.success("OTP sent to your email");
        navigate("/verify-otp", { state: { email } });
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Box
          sx={{
            width: {xs:"100%",sm:400} ,
            bgcolor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          }}
        >
          <Typography variant="h5" align="center" sx={{ mb: 3 }}>
            Forget Password
          </Typography>
          <TextField
            fullWidth
            label="Registered Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <GradientButton
            text={loading ? <CircularProgress size={20} color="inherit" /> : "Send OTP"}
            width="50%"
            onClick={handleSendOtp}
          />
        </Box>
      </Box>

      {/* Toast container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default ForgetPassword;
